import { Chip, Stack, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";
import { AppType } from "src/types/apps";

// ----------------------------------------------------------------------

export default function TypeTitle() {
	const { translate } = useLocales();
	const theme = useTheme();

	const { data: apps } = useQuery<AppType[]>({ queryKey: ["apps"], initialData: [] });

	const isEmpty = apps.length === 0;

	return (
		<Stack flexDirection={"row"} alignItems={"center"}>
			<Iconify
				icon={isEmpty ? "charm:apps-plus" : "uil:apps"}
				ml='auto'
				width={16}
				color={theme.palette.grey[700]}
				sx={{ mr: 1 }}
			/>
			<Chip
				label={translate(isEmpty ? "nav_app_section.no_apps" : "nav_app_section.pro_app")}
				sx={{ borderRadius: 0.7 }}
				size='small'
			/>
		</Stack>
	);
}
